import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import CustomInput from "../../../../components/CustomInput/CustomInput.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Button from "components/CustomButtons/Button.js";
import DeleteIcon from "@material-ui/icons/Delete";
import { setCart } from "redux/ducks/cartSlice.js";
import { delete_ } from "../../../../lib/requests.js";
import { removeCart } from "redux/ducks/cartSlice.js";
import { useNavigate } from "react-router-dom";
import { setDashboard } from "redux/ducks/CSPDashboardSlice.js";

const useStyles2 = makeStyles(headersStyle);

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Cart = () => {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const cartDetails = useSelector((state) => state.cart);
	const [originalData, setOriginalData] = useState([]);
	const [searchText, setSearchText] = useState("");
	const dispatch = useDispatch();
	const customerDetails = useSelector((state) => state.customer);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getCartsDetails();
	}, []);

	const handleSearch = (e) => {
		setSearchText(e.target.value);
		manageSearch(e.target.value);
	};

	const manageSearch = (value) => {
		const searchTerm = value.trim().toLowerCase();

		if (searchTerm.length > 0) {
			// cartDetails?.cartitems;
			const cartItems = originalData?.cartitems || [];
			const filteredData = cartItems?.filter((product) => {
				const description = product?.Description || "";
				return description.toLowerCase().includes(searchTerm);
			});
			dispatch(
				setCart({
					...cartDetails,
					cartitems: filteredData,
				})
			);
		} else {
			dispatch(
				setCart({
					...cartDetails,
					cartitems: originalData?.cartitems,
				})
			);
		}
	};

	const handleClear = () => {
		console.log("handleClear");
		document.getElementById("searchItem").value = "";
		manageSearch("");
	};

	const getCartsDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/cart/list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						dispatch(setCart(res.data.records));
						setOriginalData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						dispatch(removeCart());
						// ErrorMessage("Carts details", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Carts details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Carts details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const deleteCartItem = async (product) => {
		setLoading(true);
		try {
			await delete_(
				`/api/cart/delete/${customerDetails?.tenantId}?cart_item_id=${product?.id}&csp_order_id=${product?.csp_order_id}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						getCartsDetails();
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Products", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const emptyCart = async () => {
		setLoading(true);
		try {
			await delete_(`/api/cart/empty/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						getCartsDetails();
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Cart ", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					console.log("error", error);
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Cart ", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Cart ", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const cancelOrder = () => {
		dispatch(
			setDashboard({
				OrderSummary: false,
				ConfirmOrder: false,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: true,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
		emptyCart();
	};
	const redirectToCheckout = () => {
		dispatch(
			setDashboard({
				ConfirmOrder: true,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
				OrderSummary: false,
			})
		);
	};

	return (
		<>
			{/* <div className={classNames(classesCSStyles.searchWrapper)}>
				<input
					type="text"
					id="search"
					placeholder="Search items"
					className={classNames(
						classesCSStyles.searchInput,
						classesCSStyles?.my,
						classesCSStyles?.mx
					)}
					onChange={(e) => {
						handleSearch(e);
					}}
				/>
				<div>
					<button
						className={classNames(classes2.button, classes2.btnPrimary)}
						onClick={() => {
							handleClear();
						}}>
						X
					</button>
				</div>
			</div> */}
			{cartDetails?.cartitems?.length > 0 && (
				<div
					onClick={emptyCart}
					className={classNames(classesCSStyles.simpleBtn, classesCSStyles?.mx5)}>
					<span>Clear all items</span>
				</div>
			)}
			{loading && (
				<Loading
					width={20}
					height={20}
					className={classesCSStyles.absoluteLoading}
				/>
			)}
			<div
				className={
					loading
						? classNames(classesCSStyles.loading, classesCSStyles?.mx5)
						: classNames(classesCSStyles?.mx5)
				}>
				{cartDetails?.cartitems?.map((product, index) => (
					<div
						key={index}
						className={classNames(
							classesCSStyles?.bottomBorder,
							classesCSStyles?.py2
						)}>
						<div>
							<div className="flex">
								<div className={classesCSStyles?.labelAc}>
									<h4>{product.Description}</h4>
								</div>
								<Button
									color="danger"
									size="sm"
									simple
									onClick={() => deleteCartItem(product)}>
									<DeleteIcon />
								</Button>
							</div>
							<div>
								Price : <span>${product.price}</span> | Quantity :{" "}
								<span> {product.quantity}</span>
							</div>
						</div>
					</div>
				))}
			</div>
			{!loading && (cartDetails?.cartitems?.length === 0 || !cartDetails) && (
				<div className={classNames(classesCSStyles?.my10, classesCSStyles?.mx5)}>
					No items in cart
				</div>
			)}
			<div
				className={classNames(
					classesCSStyles.my10,
					classesCSStyles.mlAuto,
					classesCSStyles?.moveRight
				)}>
				{cartDetails?.cartitems?.length > 0 && (
					<button
						onClick={redirectToCheckout}
						type="button"
						className={classNames(classesCSStyles?.buttonPrimary)}>
						Confirm
					</button>
					// <Button color="primary" size="sm" >
					// 	Confirm
					// </Button>
				)}
				&nbsp; &nbsp;
				<Button color="danger" size="sm" onClick={cancelOrder}>
					CANCEL
				</Button>
			</div>
		</>
	);
};

export default Cart;
